import React from 'react'

function GeneralLaySpecific() {
  return (
    <embed src="\pdfs\E1.4.0.2_General_layout_specifications_04.2014_kr.pdf" width="100%" height="2100px" />
  )
}

export default GeneralLaySpecific